<style lang="scss" scoped>
@import "$vars";
.title {
  font-family: "Open Sans" !important;
  color: #666666;
  font-size: 1.5em;
  font-weight: 700;
  margin: 0;
}
.drop-active {
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  position: fixed;
  z-index: 9999;
  opacity: 0.6;
  text-align: center;
  background: #000;
  h3 {
    margin: -0.5em 0 0;
    position: absolute;
    opacity: 1;
    top: 50%;
    left: 0;
    right: 0;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    font-size: 40px;
    color: #fff;
    padding: 0;
  }
}

.column {
  margin-bottom: 25px;
}
.file-block {
  width: 100%;
  min-height: 30vh;
  border: 1px dashed #e5e5e5;
  display: flex;
  justify-content: center;
  align-items: center;
  .block {
    .icon-block {
      display: inline-block;
      .dr-icon {
        color: #494949;
        width: 40px;
      }
      .text {
        color: #616161;
        font-weight: 600;
      }
    }
    .file-list {
      list-style: none;
      .upload-file {
        font-size: 1.2em;
        font-weight: bold;
      }
    }
  }
}
.models {
  margin-top: 25px;
  .title-block {
    .title {
      font-size: 1.3em;
      font-weight: normal;
      color: #565656;
    }
  }
  .list {
    margin: 0;
    list-style: none;
    display: flex;

    align-items: flex-start;
    flex-wrap: wrap;
    .item {
      padding: 10px;
      background: #f6f6f6;
      max-width: 50%;
      min-width: 200px;
      >figure {
        padding-right: 1em;
        img {
          width: 40px
        }
      }
      display: flex;
      margin-right: 20px;
    }
  }
}

h5 {
  color: #4a4a4a;
  font-family: $base-font-family;
  font-size: 18px;
  font-weight: 600;
}

h2 {
  color: #4a4a4a;
}

#isModelDocument {
  margin-bottom: 0;
}
</style>

<template>
  <main class="component-patients">
    <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
      <h3>Arraste o arquivo para enviar</h3>
    </div>

    <h2>Documentos médicos</h2>
    <hr />
    <form @submit.prevent="submit()" class="columns">
      <div
        class="column col-5 form-group has-icon-right"
        :class="[errorClass($v.formData.name), successClass($v.formData.name)]"
      >
        <div class="has-icon-right">
        <label class="form-label left">Nome do documento&nbsp;</label>
          <input
            class="form-input"
            type="text"
            v-model="formData.name"
            placeholder="Nome do Documento"
            @blur="$v.formData.name.$touch()"
          >
        </div>
        <ul class="list-unstyled">
          <li>
            <span
              class="form-input-hint"
              style="color: red; font-weigth: 100;"
              v-if="(formData.file.length && !formData.name) || (!$v.formData.name.required && $v.formData.name.$dirty)"
            >Campo em branco</span>
          </li>
        </ul>
      </div>
      <div
        class="column col-12 form-group"
        :class="[errorClass($v.formData.file), successClass($v.formData.file)]"
      >
        <file-upload
          class="file-block"
          @input-file="updateFile"
          :headers="$store.getters.getAuthHeader"
          :multiple="false"
          :drop="true"
          :drop-directory="true"
          :accept="accept"
          :extensions="extensions"
          v-model="formData.file"
          ref="upload"
          @blur="$v.formData.file.$touch()"
        >
          <div class="block">
            <div class="icon-block">
              <dr-icon name="upload" class="dr-icon" color="#616161"></dr-icon>
            </div>
            <p class="text">Arraste os arquivos para esta área para enviar ao paciente.</p>
            <button type="button" class="btn btn-sm btn-primary">Escolher arquivo</button>
            <ul v-if="formData.file" class="file-list">
              <li v-for="file in formData.file" :key="file.id" class="upload-file">
                <span>{{file.name }}</span>
              </li>
            </ul>
          </div>
        </file-upload>
        <ul class="list-unstyled">
          <li>
            <span
              class="form-input-hint"
              v-if="!$v.formData.file.required && $v.formData.file.$dirty"
            >campo em branco</span>
          </li>
          <li v-if="formData.file[0]">
            <span
              class="form-input-hint"
              v-if="formData.file[0].name.search(extensions) === -1"
            >Extensão inválida. Envie um arquivo PDF</span>
          </li>
          <li v-for="(error, $index) in getApiErrors" :key="$index">
            <span class="form-input-hint">{{error}}</span>
          </li>
        </ul>

        <div>
          <label class="form-checkbox">
            <input type="checkbox" v-model="formData.isModelDocument">
            <i class="form-icon"></i>
            Deseja manter esse arquivo disponível para utilizar em outras consultas?
          </label>
        </div>
      </div>
      <footer>
        <dr-submit size='sm' text="Enviar" :disabled="$v.formData.$invalid" :sending="sending"></dr-submit>
      </footer>
    </form>
    <div class="models" v-if="medicalDocuments.length > 0">
      <div class="title-block">
        <h4 class="title">Arquivos para envio</h4>
      </div>
      <hr>
      <ul class="list">
        <li class="item" v-for="doc in medicalDocuments" :key="doc.id">
          <figure>
            <img :src="pdf" class="dr-icon">
          </figure>
          <span>
            <small class="name">{{doc.name}}</small><br />
            <dr-submit
              v-if="!isLinked(doc.id)"
              text="Vincular"
              color="blue"
              size="sm"
              @click="sendMedicalDocument(doc.id)"
              :disabled="sendingDocument === doc.id"
              :sending="sendingDocument === doc.id"></dr-submit>
            <dr-submit
              v-else
              text="Desvincular"
              color="yellow"
              size="sm"
              @click="sendMedicalDocument(doc.id, true)"
              :disabled="sendingDocument === doc.id"
              :sending="sendingDocument === doc.id"></dr-submit>
          </span>
        </li>
      </ul>
    </div>
  </main>
</template>

<script>
import FileUpload from 'vue-upload-component'
import drSubmit from '@/components/form/submit'
import { required } from 'vuelidate/lib/validators'
import pdf from '@/assets/img/icons/ico_png/ico_pdf.png'
import cross from '@/assets/img/icons/ico_png/ico_cross.png'
import EventBus from '@/globals/eventBus'

export default {
  props: ['isMedicalHistoryVisible', 'agenda_id'],

  components: {
    drSubmit,
    FileUpload
  },

  validations () {
    return {
      formData: {
        name: {required},
        file: {required}
      }
    }
  },

  data () {
    return {
      medicalDocuments: [],
      modelDocuments: [],
      linkedDocuments: [],
      pdf: pdf,
      cross: cross,
      formData: {
        name: null,
        file: [],
        isModelDocument: false
      },
      sendingDocument: false,
      accept: 'application/pdf',
      extensions: 'pdf',
      sending: false,
      getApiErrors: [],
      paging: false,
      pagination: {
        currentPage: 1,
        totalPages: 0,
        totalRows: 0
      }
    }
  },

  created () {
    EventBus.$on('submit-files', (args) => {
      if (!this.$v.formData.$invalid) {
        this.submit(args)
        return
      }

      this.$store.dispatch('setModalAlert', {
        title: 'Atenção',
        body: 'Este formulário contém dados inválidos e não foi possível salvá-lo.',
        size: 'md',
        active: true
      })
    })
  },

  mounted () {
    this.getAllDocuments()
  },

  methods: {
    isLinked (id) {
      for (let doc of this.linkedDocuments) {
        if (id === doc.id) {
          return true
        }
      }
    },
    sendMedicalDocument (id, remove = false) {
      const endpoint = (!remove)
        ? `/agenda/${this.agenda_id}/medical_document/${id}/link_patient`
        : `/agenda/${this.agenda_id}/medical_document/${id}`
      const method = (!remove) ? 'get' : 'delete'
      this.sendingDocument = id
      this.$http({
        url: endpoint,
        method,
        headers: this.$store.getters.getAuthHeader.headers
      })
        .then((res) => {
          // console.log(`response\n`, res)
          this.getAllDocuments()
        })
        .catch((err) => {
          console.log(`error:\n`, err)
          this.$store.dispatch('setModalAlert', {
            title: 'Erro',
            body: (typeof err === 'object') ? err.error.message : err,
            size: 'md',
            active: true
          })
        })
        .finally(() => {
          this.sendingDocument = false
        })
    },
    errorClass (item) {
      if ((item.$invalid && item.$dirty) || this.getApiErrors.length) {
        return 'has-error'
      }
      if (this.formData.file[0]) {
        if (this.formData.file[0].name.search(this.extensions) === -1) {
          return 'has-error'
        }
      }
    },
    successClass (item) {
      if (!item.$invalid) {
        return 'has-success'
      }
    },
    updateFile (file, old) {
      if (!this.formData.id) {
        return
      }
      if (!this.formData.file[0]) {
        return
      }
      if (!this.formData.file[0].fileObject) {
        return
      }
      this.sending = true
      this.apiErrors = this.fn_BUILD_API_ERRORS(this.formData)
      const data = file.file
      let headers = this.fn_COPY_OBJECT(this.$store.getters.getAuthHeader)
      let boundary = Math.random().toString().substr(2)
      headers.headers['Content-Type'] = `multipart/form-data; charset=utf-8; boundary=${boundary}`
      let formData = new FormData()
      formData.append('file[file][file]', data)
      this.fn_SHOW_PROGRESS()
      this.$http.post(`/doctor/medical_document/${this.formData.id}/file`, formData, headers).then(
        (res) => {
          let status = res.code || res.status
          if (status) {
            this.$store.dispatch('setModalAlert', {
              title: 'Sucesso',
              body: 'Arquivo atualizado!',
              size: 'md',
              active: true
            })
          }
        }
      ).catch(
        (err) => {
          console.log(err)
          this.fn_FLATTEN_OBJECT(err.errors.children).then(
            (res) => {
              for (let field in res) {
                this.apiErrors[field.replace(/.children|.errors/g, '')] = res[field]
              }
            }
          )
          console.log('apiErrors:')
          console.log(this.apiErrors)
          this.$store.dispatch('setModalAlert', {
            title: 'Erro',
            body: err.error.message,
            size: 'md',
            active: true
          })
        })
        .finally(() => {
          this.updateListMedicalDocuments()
          this.$v.$reset()
          this.fn_HIDE_PROGRESS()
          this.sending = false
        })
    },

    submit ({ showConfirmation = true, nextSection = null, nextTab = null } = {}) {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      let data = {
        name: this.formData.name,
        isModelDocument: this.formData.isModelDocument ? 1 : 0,
        file: this.formData.file[0].file
      }

      this.sending = true

      let endpoint = '/doctor/medical_document'
      let method = 'post'
      let headers = {
        Authorization: this.$store.getters.getAuthHeader.headers.Authorization
      }
      let form = null

      if (this.formData.id) {
        headers['Content-Type'] = `application/x-www-form-urlencoded`
        endpoint = `/doctor/medical_document/${this.formData.id}`
        method = 'put'
        delete data.file
        form = `name[name]=${data.name}`
      } else {
        let boundary = Math.random().toString().substr(2)
        headers['Content-Type'] = `multipart/form-data; charset=utf-8; boundary=${boundary}`
        form = new FormData()
        form.append('medical_document[name]', data.name)
        form.append('medical_document[file][file]', data.file)
        form.append('medical_document[isModelDocument]', data.isModelDocument)
      }

      EventBus.$emit('appointment-start-saving')
      this.fn_SHOW_PROGRESS()
      this.$http({
        url: endpoint,
        method,
        data: form,
        headers
      }).then(res => {
        let status = res.code || res.status
        if (status) {
          if (showConfirmation) {
            this.$store.dispatch('setModalAlert', {
              title: 'Sucesso',
              body: 'Dados atualizados',
              size: 'md',
              active: true
            })
            setTimeout(() => {
              this.$store.dispatch('setModalAlert', {
                active: false
              })
            }, 2000)
          }
        }

        // Vincula o arquivo adicionado
        const addedFileId = this.getAddedFileId(data.isModelDocument)
        addedFileId.then((res) => {
          this.sendMedicalDocument(res)
        }).catch((err) => {
          console.log('addedFile error:\n', err)
        }).finally(() => {
          this.getAllDocuments()
        })
      }).catch(err => {
        console.log(err, form)
        this.$store.dispatch('setModalAlert', {
          title: 'Erro',
          body: err.error.message,
          size: 'md',
          active: true
        })
      }).finally(() => {
        this.$v.$reset()
        this.sending = false
        this.formData.id = null
        this.formData.name = null
        this.formData.file = []
        this.formData.isModelDocument = false
        this.fn_HIDE_PROGRESS()

        if (nextSection) EventBus.$emit('consultation-change-section', nextSection)
        if (nextTab) EventBus.$emit('consultation-change-tab', nextTab)

        EventBus.$emit('appointment-stop-saving')
      })
    },

    async getAddedFileId (isModel = 0) {
      const addedFile = await this.$http.get(
        `/doctor/medical_document?filterAnd[md.isModelDocument]=${isModel}&itensPerPage=1&order[md.id]=DESC`,
        this.$store.getters.getAuthHeader
      )
      return addedFile.data.data[0].id || null
    },
    async getModelDocuments () {
      const modelDocuments = await this.$http.get(
        `/doctor/medical_document?filterAnd[md.isModelDocument]=1&itensPerPage=100`,
        this.$store.getters.getAuthHeader
      )
      return modelDocuments.data.data || []
    },
    async getLinkedDocuments () {
      const linkedDocuments = await this.$http.get(
        `/medical_document?filterAnd[a.id]=${this.$route.params.agendaId}`,
        this.$store.getters.getAuthHeader
      )
      return linkedDocuments.data.data || []
    },
    getAllDocuments () {
      const modelDocuments = this.getModelDocuments()
      const linkedDocuments = this.getLinkedDocuments()

      this.fn_SHOW_PROGRESS()

      Promise.all([modelDocuments, linkedDocuments])
        .then((res) => {
          // console.log('res \n', res)
          this.modelDocuments = res[0].filter((doc) => {
            const linkedIds = res[1].map(doc => doc.id)
            return !linkedIds.includes(doc.id)
          })
          this.linkedDocuments = res[1]
          this.medicalDocuments = [].concat(this.linkedDocuments, this.modelDocuments)
        })
        .catch((err) => {
          console.log('modelDocuments && linkedDocuments error:\n', err)
        })
        .finally(() => {
          this.fn_HIDE_PROGRESS()
        })
    },

    hasUnsavedData () {
      if (
        this.formData.file.length > 0 ||
        (this.formData.name !== null && this.formData.name !== '')
      ) {
        return true
      }

      this.$v.$touch()
      return false
    }
  }
}
</script>
